import { render, staticRenderFns } from "./AcesUpload.vue?vue&type=template&id=496bc2ed&scoped=true"
import script from "./AcesUpload.js?vue&type=script&lang=js&external"
export * from "./AcesUpload.js?vue&type=script&lang=js&external"
import style0 from "./AcesUpload.scss?vue&type=style&index=0&id=496bc2ed&prod&lang=scss&scoped=true&external"
import style1 from "./AcesUpload.vue?vue&type=style&index=1&id=496bc2ed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496bc2ed",
  null
  
)

export default component.exports